import {Component, Host, OnInit} from '@angular/core';
import {ApiInfoService} from '../../../services/api-directory.service';
import {DirectoryItemComponent} from '../directory-item.component';
import {DirectoryService} from '../../../services/directory.service';

@Component({
    templateUrl: 'info.template.html',
    providers: [ApiInfoService]
})
export class InfoComponent implements OnInit {
    public data: any;
    public parent: DirectoryItemComponent;
    showInstructionsHistory = false;

    constructor(@Host() parent: DirectoryItemComponent,
                public directoryService: DirectoryService,
                public api: ApiInfoService) {
        this.parent = parent;
        this.directoryService.residentInstructionUpdated.subscribe(instruction => {
            const index = this.data.instructions.findIndex((i => instruction.id == i.id));
            instruction.user = this.data.instructions[index].user;
            this.data.instructions[index] = instruction;
        });
    }

    ngOnInit(): void {
        this.getData(this.parent.suiteId);
    }

    update(data: any): void {
        this.api.updateItem(this.parent.suiteId, data).subscribe(() => {});
    }

    private getData(id: number): void {
        this.parent.spinnerShow = true;
        this.api.getItem(id).subscribe((res) => {
            this.data = res;
            if(this.data.instructions && this.data.instructions.length > 0)
                this.directoryService.formatResidentInstructions(this.data.instructions);
            this.parent.spinnerShow = false;
        }, err => this.parent.spinnerShow = false);
    }

    numberOfCurrentInstructions() {
        return this.data.instructions.filter(i => i.status == 'current').length;
    }

    getInstructions() {
        if(!this.showInstructionsHistory)
            return this.data.instructions.filter(i => i.status == 'current');
        else
            return this.data.instructions;
    }

    submitKeyFields(fieldName, value) {
        const data = {};
        data[fieldName] = value.map(v => ({
            user: v.user,
            fieldValue: v.fieldValue
        }));
        this.update(data);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/info/info.component.ts